/**
 * <hotel-book-bar> 顶层 React App(日期栏 + 预订)
 *
 * 用共享控制器 + DateBar(actionLabel="立即预订")。
 * handleBook:window.open 套餐列表 + 派发 book(无 packageId)。共享逻辑见 shared.ts。
 */
import { toLocalDateString } from '../lib/date';
import type { BookPayload } from '../types';
import { useDateBarController, openUrl, dispatch, type AppProps } from './shared';
import { DateBar } from './DateBar';

export function BookBarApp({ initialCheckIn, initialCheckOut, host }: AppProps) {
  const { hotel, dates, handleDateChange } = useDateBarController(
    host,
    initialCheckIn,
    initialCheckOut
  );

  const handleBook = () => {
    openUrl('/packages', {
      checkIn: toLocalDateString(dates.checkIn),
      checkOut: toLocalDateString(dates.checkOut),
    });
    const payload: BookPayload = {
      checkIn: toLocalDateString(dates.checkIn),
      checkOut: toLocalDateString(dates.checkOut),
    };
    dispatch(host, 'book', payload);
  };

  if (hotel !== 'ok') return null;

  return (
    <DateBar
      checkIn={dates.checkIn}
      checkOut={dates.checkOut}
      onDateChange={handleDateChange}
      actionLabel="立即预订"
      onAction={handleBook}
    />
  );
}
